import { render, staticRenderFns } from "./creatLevel.vue?vue&type=template&id=283bcf00&scoped=true"
import script from "./creatLevel.vue?vue&type=script&lang=js"
export * from "./creatLevel.vue?vue&type=script&lang=js"
import style0 from "./creatLevel.vue?vue&type=style&index=0&id=283bcf00&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283bcf00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('283bcf00')) {
      api.createRecord('283bcf00', component.options)
    } else {
      api.reload('283bcf00', component.options)
    }
    module.hot.accept("./creatLevel.vue?vue&type=template&id=283bcf00&scoped=true", function () {
      api.rerender('283bcf00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/level/creatLevel.vue"
export default component.exports